import i18n from "@/i18n.js";

const UsersCompanies = () => {
  return (
    <>
      <div className="col">
        <div className="card">
          <div className="card-body p-1">
            <div className="card-title p-1">
              <h5 className="card-title p-1">{i18n.t("page.issuerList")}</h5>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UsersCompanies;
